import Button from '@restart/ui/esm/Button';
import React, { useEffect, useState } from 'react'
import { Card, Carousel, ListGroup } from 'react-bootstrap'
import Container from './../Container/Container';

export default function Home() {
    const [courseContainer,setcourseContainer] = useState([]);
    const [reviewer,setReviewer] = useState([]);

    useEffect(()=>{
        fetch('information.json')
        .then(response=>response.json())
        .then(data=>setcourseContainer(data));
    },[])


    useEffect(() => {
        fetch('review.json')
        .then(response=>response.json())
        .then(data=>setReviewer(data));
    }, [])



    return (
        <div>
            {/* Course Advertisement SLider */}
            <Carousel className="mt-4 container">
                {
                    courseContainer.map(course=>
                    <Carousel.Item>
                        <img
                            className="d-block w-100"
                            src={course.img}
                            alt={course.title}
                            height="400px"
                        />
                    </Carousel.Item>)
                }
            </Carousel>
            <h3 className="text-center text-success mt-3">
                Trending Now
            </h3>
            <div className='container mt-3 ms-auto'>
                <div className="row justify-content-center">
                {
                    courseContainer.slice(0, 4).map(course=>
                        <Container key={course.id} obj={course}></Container>
                        )
                }
                </div>
                <h3 className="text-center text-success mt-3">
                    From LearnWithEvan Community
                </h3>
                    <div className="row justify-content-center">
                        {
                            reviewer.map(review=>
                            <Container key={review.id} obj = {review}>

                            </Container>)
                        }
                    </div>
            </div>
        </div>
    )
}
